export default __webpack_public_path__ + "static/media/computer.6fd4de04.svg";